import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SecondHandSupply } from '../../models/second-hand-supply';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {
  /* --------------------------------- Fields --------------------------------- */
  oldSecondHandSupply: SecondHandSupply;
  /* ------------------------------- Constructor ------------------------------ */

  constructor(private route: ActivatedRoute) { }
/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
    if(this.route.snapshot.data && this.route.snapshot.data.oldSecondHandSupply){
      this.oldSecondHandSupply = this.route.snapshot.data.oldSecondHandSupply;
    }
  }
  /* ---------------------------- Custom Functions ---------------------------- */

  viewItems() {

  }
}
